import { render } from "./BaseModalButton.vue?vue&type=template&id=67625150&scoped=true"
import script from "./BaseModalButton.vue?vue&type=script&lang=js"
export * from "./BaseModalButton.vue?vue&type=script&lang=js"

import "./BaseModalButton.vue?vue&type=style&index=0&id=67625150&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67625150"]])

export default __exports__